<template>
  <div class="main-layout">
    <header class="layout-header">
      <slot name="header"></slot>
    </header>
    <!-- [PERUBAHAN] Menambahkan :class kondisional -->
    <main class="layout-main-content" :class="{ 'is-centered': shouldCenterContent }">
      <slot name="main"></slot>
    </main>
    <footer class="layout-footer">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script setup>
import { computed } from 'vue';

// [BARU] Menerima appState sebagai prop dari App.vue
const props = defineProps({
  appState: {
    type: String,
    required: true
  }
});

// [BARU] Computed property untuk menentukan kapan konten harus di tengah
const shouldCenterContent = computed(() => {
  return props.appState === 'THANKS' || props.appState === 'RESULTS' || props.appState === 'BARCODE';
});
</script>

<style scoped>
.main-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;        /* fallback */
  min-height: -webkit-fill-available; /* iOS Safari: excludes browser chrome */
  min-height: 100dvh;       /* modern: dynamic viewport height */
  background-color: transparent;
  /* background-color: #f2f2f3; */
  position: relative;
  z-index: 1;
}

.layout-header, .layout-footer {
  flex-shrink: 0;
}
.layout-header {
  position: sticky;
  top: 0;
  z-index: 10;
}

/* [PERUBAHAN] Style default dan kondisional */
.layout-main-content {
  flex-grow: 1;
  width: 100%;
  padding: 2rem 1rem;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  
  /* Secara default, konten akan mulai dari atas */
  justify-content: center;
  gap: 2rem;
  transition: justify-content 0.5s ease;
}

/* Style ini hanya akan aktif jika class 'is-centered' ditambahkan */
.layout-main-content.is-centered {
  justify-content: center;
  gap: 0; /* Hapus gap saat di tengah agar benar-benar presisi */
}

@media (max-width: 640px) {
  .layout-main-content {
    padding: 1.5rem 1rem;
    gap: 1.5rem;
  }
}
</style>
